import React from "react";
import './GenericInfo.css'
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import BuyBtn from "../../MiniComponents/BuyBtn/BuyBtn";







export default function GenericInfo({title,lefttitle,leftText,leftImage,image,imageWidth}){
    const navigate = useNavigate()
    return(
        <div className="genericinfo__container">
             <div className="genericinfo__head">
                 {title}
             </div>
             <div className="genericinfo__content">
                
                <div className="genericinfo__left">
                   <p>{lefttitle}</p>
                   <p>{leftText}</p>
                   <div style={{width:'fit-content'}}>
                   <div onClick={()=>{navigate('/plans')}}> 
      {/*       <BuyBtn/> */}
            </div>
                   </div>
                </div>
                <div className="genericinfo__right">
                   <img className="genericinfoimg" /* width={'100%'} */ width={'70%'} src={image} alt="image right" />
                </div>
             </div>
        </div>
    )
}